import Modal from './Modal'

export * from './Modal'

export default Modal
